import { useMediaQuery } from 'react-responsive';
import sassVariables from '../../assets/stylesheets/_settings.global.scss';

const useIsMobile = () => useMediaQuery({ query: `(max-width: ${sassVariables.breakpointSmallMax})` });
const useIsMobileOrTablet = () => useMediaQuery({ query: `(max-width: ${sassVariables.breakpointMediumMax})` });
const useIsLarge = () => useMediaQuery({ query: `(min-width: ${sassVariables.breakpointLargeMin})` });
const useIsXLarge = () => useMediaQuery({ query: `(min-width: ${sassVariables.breakpointXlargeMin})` });
const useIsXXLarge = () => useMediaQuery({ query: `(min-width: ${sassVariables.breakpointXxlargeMin})` });

export default function useDefaultTheme({ theme = {}, ...props }) {
  const dft = {
    ...sassVariables,
    isMobile: useIsMobile(),
    isMobileOrTablet: useIsMobileOrTablet(),
    isLarge: useIsLarge(),
    isXLarge: useIsXLarge(),
    isXXLarge: useIsXXLarge(),
  };
  return {
    ...props,
    // we always allow additional themes to override our defaults.
    theme: { ...dft, ...theme },
  };
}

export {
  useIsMobile,
  useIsMobileOrTablet,
  useIsLarge,
  useIsXLarge,
  useIsXXLarge,
};
